<template>
  <div>
    <b-row>
      <b-col md="10" class="settings-panel">
        <div class="card">
          <div class="card-header text-center">
            Security Settings
          </div>
          <b-row>
            <b-col class="settings-panel-body securitysetting" v-if="form">
              <div class="card-block">
                <b-form>
                  <b-form-group id="exampleInputGroup1" label="Allow Account Access From From These IPS Only" label-for="ips" class="py-2">
                    <b-row>
                      <b-col class="label-desc">
                        You can either add a specific IP or a range of IP addresses ( e.g 203.0.113.* and 203.0.113.10 - 203.0.113.30 )"
                      </b-col>
                    </b-row>
                    <b-row>
                      <div class="col-md-4 ">
                        <b-form-input id="ips" type="text" v-model="newIpAddress" required placeholder="xxx.xxx.xxx.xxx">
                        </b-form-input>

                      </div>
                      <div class="col-md-4 p-0">
                        <b-btn variant="outline-secondary" size="lg" @click="addIps">Add Ips</b-btn>
                      </div>

                    </b-row>
                    <p class="form-input-note">Your current IP address is {{appInfo.IP}}</p>

                  </b-form-group>
                  <ul class="m-100 p-0">
                    <li v-for="(ip,index) in form.allowedLoginIPs" :key="index" class="chips">
                      {{ip}}
                      <a class="close-link" @click="removeIp(index)">
                        <close-icon class="icon-default closedark"></close-icon>
                      </a>
                    </li>
                  </ul>
                  <hr/>
                  <div class="m-100">
                    <h6>HTTP Authentication / Folder Protection</h6>
                    <p class="label-note">Enter your pre-configured Folder Protection credentials
                      <a class="helper-links" target="_blank" :href="appInfo.SUPPORT_URL+'solution/articles/213798'+appInfo.GA_HELP_TRACKING">Why is this needed?</a>
                    </p>
                    <b-form inline>
                      <b-input v-model="form.httpAuth.username" class="mb-2 mr-sm-2 mb-sm-0" id="user_input" placeholder="User name" />
                      <password-input idFor="inlineFormInputName3" v-model="form.httpAuth.password"></password-input>
                    </b-form>
                  </div>

                  <hr/>
                  <!-- <b-form-group label="Two - Factor Authentication">
                                        <b-form-radio-group id="radios2" name="radioSubComponent" v-model="form.loginAuthType">
                                            <b-form-radio value="authNone">Off</b-form-radio>
                                            <b-form-radio value="authBasic">Email Notification</b-form-radio>
                                        </b-form-radio-group>
                                        <p class="helper-text" v-if="twoFactor=='second'">A link and a 6-digit passcode will be sent to your email. You can either click on the link to login instantly or paste in the passcode to login.</p>
                                    </b-form-group>
                                    <hr/> -->
                  <b-form-group>
                    <b-form-checkbox v-model="form.enableHTTPS" value="1" unchecked-value="0">Enable HTTPS (Make sure this link -
                      <a class="helper-links" :href="'https://'+appInfo.APP_DOMAIN_PATH" target="blank">https://{{appInfo.APP_DOMAIN_PATH}}</a> works before enabling HTTPS)
                    </b-form-checkbox>
                  </b-form-group>
                </b-form>
              </div>
            </b-col>
          </b-row>
          <div class="card-footer text-muted text-right">
            <b-btn variant="primary" size="sm" @click="saveChanges">Save Changes
              <spinner size="small" v-if="buttonLoaders.saveChanges"></spinner>
            </b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PasswordInput from '../Common/PasswordInput';

import CloseIcon from '../../assets/close.svg';
import Vue from 'vue';
export default {
  name: 'securitysettings',
  props: ['settings'],
  components: {
    PasswordInput,
    CloseIcon
  },
  created() {
    this.appInfo = this.$store.getters.getAppInfo;
    let form = null;
    if (this.settings) {
      let settings = _.cloneDeep(this.settings);
      form = settings.securitySettings;
      if (form && form.loginAuthType === null) {
        form.loginAuthType = 'authNone';
      }
      if (form && !form.httpAuth) {
        form.httpAuth = {
          username: '',
          password: ''
        };
      }
    }
    
    this.form = form;
  },
  data() {
    return {
      appInfo: {},
      form: {},
      appURL: window.appURL,
      buttonLoaders: {
        saveChanges: false
      },
      twoFactor: 'first',
      newIpAddress: ''
    };
  },
  methods: {
    addIps() {
      this.form.allowedLoginIPs.push(this.newIpAddress);
      this.newIpAddress = '';
    },
    removeIp(index) {
      this.form.allowedLoginIPs.splice(index, 1);
    },
    saveChanges() {
      this.buttonLoaders.saveChanges = true;
      let payload = {};
      this.form.allowedLoginIPsCount = this.form.allowedLoginIPs.length;
      payload.requiredData = {
        updateSettingsAllV3: {
          securitySettings: this.form
        },
        getSettingsAllV3: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.saveChanges = false;
        this.$store.commit('SET_SETTINGS', response.data.getSettingsAllV3);
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Settings/SecuritySettings.vue